import { render, staticRenderFns } from "./AdvisorApprove.vue?vue&type=template&id=31bf4de0"
import script from "./AdvisorApprove.vue?vue&type=script&lang=js"
export * from "./AdvisorApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports